export default "__VITE_ASSET__da7a6771__"